const isReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)"
).matches;

/* -------------------------------------------------- */
/* External Links */
/* -------------------------------------------------- */
/* Mark external links with an ↗ icon */
/* -------------------------------------------------- */

let externalLinks = document.querySelectorAll(
  '.text-wrap a[href^="http"]:not(.logo_inner):not(a[href*="stadtwerke-freudenstadt.de"]):not(figure a)'
);

externalLinks.forEach(function (externalLink) {
  externalLink.insertAdjacentHTML(
    "beforeend",
    `
    <svg class="external-link" aria-label="Externer Link" width="1ch" height="1ch" viewBox="0 0 7 7" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.03977 6.81037L0.375 6.1456L5.31818 1.19389H1.5L1.50852 0.273438H6.90341V5.67685H5.97443L5.98295 1.85866L1.03977 6.81037Z"/>
    </svg>
  `
  );
});

let selectedAttraction = 0.025;
let friction = 0.28;

if (isReducedMotion) {
  selectedAttraction = 1;
  friction = 1;
}

// Initialize Flickity
document.querySelectorAll(".flickity").forEach((slider) => {
  let flkty = new Flickity(slider, {
    pageDots: true,
    prevNextButtons: false,
    wrapAround: true,
    imagesLoaded: true,
    autoPlay: 7000,
    cellAlign: "left",
    selectedAttraction,
    friction,
  });

  // Add Play/Pause Autplay Button
  let autoplayToggle = document.createElement("button");
  autoplayToggle.className = "autoplay-toggle";

  autoplayToggle.insertAdjacentHTML(
    "beforeend",
    `
    <svg class="autoplay-toggle__icon autoplay-toggle__icon--play" aria-label="Autoplay starten" width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 5v14l11-7z"/>
    </svg>
  `
  );

  autoplayToggle.insertAdjacentHTML(
    "beforeend",
    `
    <svg class="autoplay-toggle__icon autoplay-toggle__icon--pause" aria-label="Autoplay anhalten" width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
    </svg>
  `
  );

  autoplayToggle.setAttribute("aria-pressed", "false");

  slider.appendChild(autoplayToggle);

  autoplayToggle.addEventListener("click", function () {
    if (autoplayToggle.getAttribute("aria-pressed") == "true") {
      flkty.playPlayer();
      autoplayToggle.setAttribute("aria-pressed", "false");
    } else {
      flkty.stopPlayer();
      autoplayToggle.setAttribute("aria-pressed", "true");
    }
  });

  // Get all the anchor tags inside the slides
  var anchors = flkty.slider.querySelectorAll(".slide a");

  // Iterate over each anchor
  anchors.forEach(function (anchor) {
    // Add a focus event listener to the anchor
    anchor.addEventListener("focus", function (e) {
      e.preventDefault();

      let slide = anchor.closest(".slide");

      // Get the index of the slide containing the focused anchor
      var slideIndex = flkty.cells.findIndex(function (cell) {
        return cell.element.contains(anchor);
      });

      // Switch to the corresponding slide
      flkty.select(slideIndex, false, true);

      slide.scrollIntoView({
        behavior: "auto",
        block: "nearest",
        inline: "center",
      });
    });
  });
});

import { AsyncCompiler } from "sass";
// Initialize Photoswipe
import PhotoSwipeLightbox from "./photoswipe-lightbox.esm.min.js";
const lightbox = new PhotoSwipeLightbox({
  pswpModule: "./photoswipe.esm.min.js",
  gallerySelector: ".gallery",
  childSelector: "a.lightbox",
  initialZoomLevel: "fit",
  secondaryZoomLevel: "fit",
});
lightbox.init();

// Search
function closeSearch() {
  let searchOverlay = document.querySelector(".search_overlay");
  if (searchOverlay) {
    searchOverlay.classList.remove("da");
    setTimeout(function () {
      searchOverlay.remove();
    }, 250);
    document.body.classList.remove("no_scroll");
  }
}
function openSearch(link) {
  document.body.classList.add("no_scroll");
  let overlay = document.createElement("div");
  overlay.classList.add("search_overlay");
  overlay.innerHTML = `
    <div class="search_content">
      <form method="POST" action="${link.getAttribute("data-href")}">
        <label for="search-input" class="visually-hidden">Suchbegriff</label>
        <input id="search-input" placeholder="Suchen…" type="text" class="s" name="s" aria-label="Search">
        <button type="submit" class="visually-hidden">Suchen</button>
      </form>
    </div>
  `;
  document.body.appendChild(overlay);
  setTimeout(function () {
    overlay.classList.add("da");
  }, 10);
  setTimeout(function () {
    overlay.querySelector("input").focus();
  }, 250);
  overlay.addEventListener("click", function (event) {
    if (!overlay.querySelector(".search_content").contains(event.target)) {
      closeSearch();
    }
  });
  overlay.addEventListener("keyup", function (e) {
    if (e.keyCode === 27) {
      closeSearch();
    }
  });
}

let searchButtons = document.querySelectorAll("a.search");
searchButtons.forEach(function (searchButton) {
  searchButton.addEventListener("click", function (e) {
    e.preventDefault();
    openSearch(searchButton);
  });
});

// Timeline
function initTimelines() {
  let timelines = document.querySelectorAll(".timeline");
  timelines.forEach(function (timeline) {
    if (timeline.offsetParent === null || timeline.initialized) {
      return;
    }
    timeline.initialized = true;
    let line = timeline.querySelector(".line");
    gsap.set(line, {
      transformOrigin: "top",
      scaleY: 0,
    });
    gsap.to(line, {
      scaleY: 1,
      ease: "none",
      scrollTrigger: {
        trigger: timeline,
        start: "top bottom-=200",
        end: "bottom bottom-=200",
        scrub: true,
      },
    });
    let timelineBlocks = document.querySelectorAll(".timeline_block");
    timelineBlocks.forEach(function (timelineBlock) {
      ScrollTrigger.matchMedia({
        "(min-width: 1000px)": function () {
          let animation = gsap.timeline({
            scrollTrigger: {
              trigger: timelineBlock,
              start: "top bottom-=200",
              end: "top center",
              scrub: true,
            },
          });
          let icon = timelineBlock.querySelector(".icon");
          let image = timelineBlock.querySelector(".image");
          let text = timelineBlock.querySelectorAll(
            ".text h3, .text h4, .text p"
          );
          let x = 20;
          if (timelineBlock.classList.contains("align_right")) {
            x = -20;
          }
          gsap.set(icon, {
            scale: 0,
          });
          animation.to(icon, {
            scale: 1,
          });
          gsap.set(text, {
            autoAlpha: 0,
            x,
          });
          animation.to(text, {
            autoAlpha: 1,
            stagger: 0.2,
            x: 0,
          });
          gsap.set(image, {
            autoAlpha: 0,
            x: x * -1,
          });
          animation.to(
            image,
            {
              autoAlpha: 1,
              ease: "none",
            },
            "<"
          );
          animation.to(
            image,
            {
              x: 0,
            },
            "<"
          );

          return function () {
            animation.kill();
            gsap.set([icon, text, image], {
              clearProps: "all",
            });
          };
        },
      });
    });
    gsap.to(timeline, {
      autoAlpha: 1,
    });
  });
}

window.addEventListener("load", function () {
  if (isReducedMotion) {
    gsap.set(".timeline", {
      autoAlpha: 1,
    });
  } else {
    initTimelines();
  }
});

let moreLinks = document.querySelectorAll("a.more, a.less");
moreLinks.forEach(function (moreLink) {
  moreLink.addEventListener("click", function (e) {
    setTimeout(function () {
      ScrollTrigger.refresh();
    }, 250);
  });
});

// Quick Access
if (!isReducedMotion) {
  gsap.set(".quick_access .q", {
    xPercent: -100,
  });
}
let quickAccessAnimation = gsap.timeline({ paused: true });
gsap.to(".quick_access .q", {
  autoAlpha: 1,
  xPercent: 0,
  stagger: 0.1,
});
window.addEventListener("load", function () {
  quickAccessAnimation.play();
});

// Menu
let menuItemToggles = document.querySelectorAll(".menu_item_toggle");
menuItemToggles.forEach(function (menuItemToggle) {
  menuItemToggle.addEventListener("click", function (e) {
    menuItemToggles.forEach(function (otherMenuItem) {
      if (otherMenuItem != menuItemToggle) {
        otherMenuItem.closest(".menu_item").classList.remove("submenu_open");
      }
    });
    menuItemToggle.closest(".menu_item").classList.toggle("submenu_open");
    e.preventDefault();
  });
});

// Accordion
let drawers = document.querySelectorAll(".drawer");
drawers.forEach(function (drawer) {
  let duration = 0.25;

  if (isReducedMotion) {
    duration = 0;
  }

  let more = drawer.querySelector(".more");
  let less = drawer.querySelector(".less");
  if (more && less) {
    more.addEventListener("click", function (e) {
      let drawerState = Flip.getState(drawer);
      drawer.classList.add("is_open");
      window.location.hash = more.getAttribute("href");
      Flip.from(drawerState, {
        simple: true,
        duration,
        ease: "power1.inOut",
      });
      e.preventDefault();
    });
    less.addEventListener("click", function (e) {
      let drawerState = Flip.getState(drawer);
      drawer.classList.remove("is_open");
      window.location.hash = "!";
      Flip.from(drawerState, {
        simple: true,
        duration,
        ease: "power1.inOut",
      });
      e.preventDefault();
    });
  }
});

// Kunde Radio
let radioWraps = document.querySelectorAll(".radio_wrap.kunde");
radioWraps.forEach(function (radioWrap) {
  let radioButtons = radioWrap.querySelectorAll("input");
  radioButtons.forEach(function (radioButton) {
    radioButton.addEventListener("change", function (e) {
      if (radioButton.value == "Gewerbe") {
        let personenWraps = radioWrap
          .closest(".tarifrechner")
          .querySelectorAll(".personen_wrap_wrap");
        personenWraps.forEach(function (personenWrap) {
          personenWrap.classList.add("hidden_kunde");
        });
      } else if (radioButton.value == "Privat") {
        let personenWraps = radioWrap
          .closest(".tarifrechner")
          .querySelectorAll(".personen_wrap_wrap");
        personenWraps.forEach(function (personenWrap) {
          personenWrap.classList.remove("hidden_kunde");
        });
      }
    });
  });
});

// Strom/Erdgas Radio
radioWraps = document.querySelectorAll(".radio_wrap.typ");
radioWraps.forEach(function (radioWrap) {
  let radioButtons = radioWrap.querySelectorAll("input");
  radioButtons.forEach(function (radioButton) {
    radioButton.addEventListener("change", function (e) {
      if (radioButton.value == "Strom") {
        radioWrap
          .closest("form")
          .setAttribute("action", radioButton.dataset.url);
        radioWrap
          .closest(".tarifrechner")
          .querySelector(".zaehlertyp_wrap_wrap")
          .classList.remove("hidden_typ");

        radioWrap
          .closest(".tarifrechner")
          .querySelector(".personen_wrap_wrap:not(.wohnflaeche)")
          .classList.remove("hidden_typ");
        radioWrap
          .closest(".tarifrechner")
          .querySelector(".personen_wrap_wrap.wohnflaeche")
          .classList.add("hidden_typ");

        var event = new Event("change");
        radioWrap
          .closest(".tarifrechner")
          .querySelector(".personen_wrap_wrap:not(.wohnflaeche) input:checked")
          ?.dispatchEvent(event);
      } else if (radioButton.value == "Erdgas") {
        radioWrap
          .closest("form")
          .setAttribute("action", radioButton.dataset.url);
        document.querySelector(
          '[name="zaehlertyp"][value="Eintarifzähler"]'
        ).checked = true;
        document
          .querySelector('[name="zaehlertyp"][value="Zweitarifzähler"]')
          .removeAttribute("checked");
        checkZaehlertyp(
          document.querySelector('[name="zaehlertyp"][value="Eintarifzähler"]')
        );
        checkZaehlertyp(
          document.querySelector('[name="zaehlertyp"][value="Zweitarifzähler"]')
        );
        radioWrap
          .closest(".tarifrechner")
          .querySelector(".zaehlertyp_wrap_wrap")
          .classList.add("hidden_typ");

        radioWrap
          .closest(".tarifrechner")
          .querySelector(".personen_wrap_wrap:not(.wohnflaeche)")
          .classList.add("hidden_typ");
        radioWrap
          .closest(".tarifrechner")
          .querySelector(".personen_wrap_wrap.wohnflaeche")
          .classList.remove("hidden_typ");

        var event = new Event("change");
        radioWrap
          .closest(".tarifrechner")
          .querySelector(".personen_wrap_wrap.wohnflaeche input:checked")
          ?.dispatchEvent(event);
      } else if (radioButton.value == "Wärmestrom") {
        radioWrap
          .closest("form")
          .setAttribute("action", radioButton.dataset.url);
        radioWrap
          .closest(".tarifrechner")
          .querySelector(".zaehlertyp_wrap_wrap")
          .classList.remove("hidden_typ");

        radioWrap
          .closest(".tarifrechner")
          .querySelector(".personen_wrap_wrap:not(.wohnflaeche)")
          .classList.add("hidden_typ");
        radioWrap
          .closest(".tarifrechner")
          .querySelector(".personen_wrap_wrap.wohnflaeche")
          .classList.add("hidden_typ");

        checkZaehlertyp(
          document.querySelector('[name="zaehlertyp"]:checked')
        );
      }
    });
  });
});

// Zählertyp Radio
function checkZaehlertyp(radioButton) {
  if (radioButton.checked && radioButton.value == "Eintarifzähler") {
    radioButton
      .closest(".tarifrechner")
      .querySelector('.input_wrap[data-zaehlertyp="zweitarifzaehler"]')
      .classList.add("hidden_zaehlertyp");
    radioButton
      .closest(".tarifrechner")
      .querySelector('.input_wrap[data-zaehlertyp="eintarifzaehler"]')
      .classList.remove("hidden_zaehlertyp");
    let personenWraps = radioButton
      .closest(".tarifrechner")
      .querySelectorAll(".personen_wrap_wrap");
    personenWraps.forEach(function (personenWrap) {
      personenWrap.classList.remove("hidden_zaehlertyp");
    });
    radioButton
      .closest(".tarifrechner")
      .querySelector('input[name="jahresverbrauch"]')
      .setAttribute("required", true);
    radioButton
      .closest(".tarifrechner")
      .querySelector('input[name="jahresverbrauch_ht"]')
      .removeAttribute("required");
    radioButton
      .closest(".tarifrechner")
      .querySelector('input[name="jahresverbrauch_nt"]')
      .removeAttribute("required");
  } else if (radioButton.checked && radioButton.value == "Zweitarifzähler") {
    radioButton
      .closest(".tarifrechner")
      .querySelector('.input_wrap[data-zaehlertyp="zweitarifzaehler"]')
      .classList.remove("hidden_zaehlertyp");
    radioButton
      .closest(".tarifrechner")
      .querySelector('.input_wrap[data-zaehlertyp="eintarifzaehler"]')
      .classList.add("hidden_zaehlertyp");
    let personenWraps = radioButton
      .closest(".tarifrechner")
      .querySelectorAll(".personen_wrap_wrap");
    personenWraps.forEach(function (personenWrap) {
      personenWrap.classList.add("hidden_zaehlertyp");
    });
    radioButton
      .closest(".tarifrechner")
      .querySelector('input[name="jahresverbrauch"]')
      .removeAttribute("required");
    radioButton
      .closest(".tarifrechner")
      .querySelector('input[name="jahresverbrauch_ht"]')
      .setAttribute("required", true);
    radioButton
      .closest(".tarifrechner")
      .querySelector('input[name="jahresverbrauch_nt"]')
      .setAttribute("required", true);
  }
}
radioWraps = document.querySelectorAll(".radio_wrap.zaehlertyp");
radioWraps.forEach(function (radioWrap) {
  let radioButtons = radioWrap.querySelectorAll("input");
  radioButtons.forEach(function (radioButton) {
    radioButton.addEventListener("change", function (e) {
      checkZaehlertyp(radioButton);
    });
  });
});

// Filter

if (document.querySelector("nav.filter")) {
  let filterSelects = document.querySelectorAll(".filter_select_wrap");

  filterSelects.forEach(function (filterSelect) {
    let select = filterSelect.querySelector("select");
    select.addEventListener("change", function (e) {
      var selectedOption = select.querySelector("option:checked");
      if (selectedOption.classList.contains("all")) {
        filterSelect.classList.remove("is_active");
      } else {
        filterSelect.classList.add("is_active");
      }
      filter();
    });
  });

  let filterSearch = document.querySelector(".filter_search");

  filterSearch.addEventListener("input", function (e) {
    filter();
  });

  let filters = {};

  document
    .querySelector(".filter_button")
    .addEventListener("click", function (e) {
      filterSelects.forEach(function (filterSelect) {
        filterSelect.querySelector("select").selectedIndex = 0;
        filterSelect.classList.remove("is_active");
      });
      filterSearch.value = "";
      filter();
      e.preventDefault();
    });

  function updateFilter() {
    filterSelects.forEach(function (filterSelect) {
      let select = filterSelect.querySelector("select");
      var selectedOption = select.querySelector("option:checked");
      let filterGroup = filterSelect.dataset.filter;
      filters[filterGroup] = selectedOption.dataset.filter;
    });
  }

  function filter() {
    updateFilter();
    let filterBlocks = document.querySelectorAll(".filter_block");
    filterBlocks.forEach(function (filterBlock) {
      // Search
      filterBlock.classList.remove("search_filtered");
      var text = filterSearch.value;
      var pat = new RegExp(text, "i");
      if (pat.test(filterBlock.textContent)) {
        filterBlock.classList.remove("search_filtered");
      } else {
        filterBlock.classList.add("search_filtered");
      }

      // Filter 1
      filterBlock.classList.remove("filter1_filtered");
      if (filters.filter1) {
        let filtered = true;
        if (filterBlock.dataset.filter1) {
          filterBlock.dataset.filter1
            .split("; ")
            .forEach(function (filterBlockFilter) {
              if (filters.filter1 == filterBlockFilter) {
                filtered = false;
                return;
              }
            });
        }
        if (filtered) {
          filterBlock.classList.add("filter1_filtered");
        }
      }

      // Filter 2
      filterBlock.classList.remove("filter2_filtered");
      if (filters.filter2) {
        let filtered = true;
        if (filterBlock.dataset.filter2) {
          filterBlock.dataset.filter2
            .split("; ")
            .forEach(function (filterBlockFilter) {
              if (filters.filter2 == filterBlockFilter) {
                filtered = false;
                return;
              }
            });
        }
        if (filtered) {
          filterBlock.classList.add("filter2_filtered");
        }
      }

      let url = document.body.dataset.url;
      for (const filterKey in filters) {
        if (filters[filterKey]) {
          url = url + "/" + filterKey + ":" + filters[filterKey];
        }
      }

      if (window.location != url) {
        history.pushState(null, null, url);
      }
    });

    // No results
    let filteredBlocks = document.querySelectorAll(
      ".filter_block:not(.search_filtered):not(.filter1_filtered):not(.filter2_filtered)"
    );
    if (!filteredBlocks.length) {
      document.querySelector(".no_results").classList.add("is_active");
    } else {
      document.querySelector(".no_results").classList.remove("is_active");
    }
  }

  filter();
}

let overlay = document.querySelector(".overlay");

if (overlay) {
  overlay.addEventListener("click", function (e) {
    if (
      !e.target.matches(".overlay_inner, .overlay_inner *") ||
      e.target.matches(".close_overlay, .close_overlay *")
    ) {
      gsap.to(".overlay_inner", {
        autoAlpha: 0,
        duration: 0.25,
        onComplete: function () {
          gsap.to(".overlay", {
            autoAlpha: 0,
            duration: 0.25,
            onComplete: function () {
              overlay.remove();
            },
          });
        },
      });
      e.preventDefault();
    }
  });
}

// Tarife
document.querySelectorAll(".tarife_cards_inner").forEach((tarifeCarousel) => {
  // Carousel
  tarifeCarousel.flkty = new Flickity(tarifeCarousel, {
    pageDots: false,
    prevNextButtons: true,
    imagesLoaded: true,
    cellAlign: "left",
    groupCells: true,
    selectedAttraction,
    friction,
  });

  // Tarife Toggle
  tarifeCarousel
    .querySelectorAll(".tarife_card_inner")
    .forEach((tarifeCard) => {
      tarifeCard
        .querySelectorAll(".details_toggle")
        .forEach((detailsToggle) => {
          detailsToggle.addEventListener("click", function (e) {
            tarifeCard.classList.add("with_details");
            tarifeCarousel.flkty.resize();
            e.preventDefault();
          });
        });
    });
});

function filterTarife(zaehlertyp, kunde) {
  let tarifeCards = document.querySelectorAll(".tarife_card");
  tarifeCards.forEach(function (tarifeCard) {
    let tarifeCardZaehlertyp = tarifeCard.dataset.zaehlertyp;
    let tarifeCardKunde = tarifeCard.dataset.kunde;
    if (!tarifeCardZaehlertyp) {
      tarifeCardZaehlertyp = zaehlertyp;
    }
    if (tarifeCardZaehlertyp == zaehlertyp && tarifeCardKunde == kunde) {
      tarifeCard.classList.remove("hidden");
    } else {
      tarifeCard.classList.add("hidden");
    }
    tarifeCard.closest(".tarife_cards_inner").flkty.resize();
  });

  let visibleCount = document.querySelectorAll(".tarife_card:not(.hidden)").length;
  let noResults = document.querySelector(".tarife_no_results");
  let cardsWrap = document.querySelector(".tarife_cards");
  if (noResults) noResults.classList.toggle("is_hidden", visibleCount > 0);
  if (cardsWrap) cardsWrap.classList.toggle("is_hidden", visibleCount === 0);
}

function rechneTarife(typ, jahresverbrauch) {
  let tarifeCards = document.querySelectorAll(".tarife_card");

  let zaehlertyp = "Eintarifzähler";

  let jahresverbrauch_nt, jahresverbrauch_ht;

  if (Array.isArray(jahresverbrauch)) {
    zaehlertyp = "Zweitarifzähler";
    jahresverbrauch_nt = parseFloat(jahresverbrauch[0]);
    jahresverbrauch_ht = parseFloat(jahresverbrauch[1]);
  } else {
    jahresverbrauch = parseFloat(jahresverbrauch);
  }

  tarifeCards.forEach(function (tarifeCard) {
    if (tarifeCard.matches(".hidden")) return;
    if (tarifeCard.dataset.dynamic === "true") return;

    let grundpreisValue =
      tarifeCard.querySelector(".grundpreis .value").innerHTML;
    grundpreisValue = grundpreisValue
      .replace("€", "")
      .replace(" ", "")
      .replace(",", ".");
    let grundpreis = parseFloat(grundpreisValue);

    let gesamtpreis = tarifeCard.querySelector(".kosten .value");

    let gesamtpreisValue;

    // Strom / Wärmestrom, Zweitarifzähler
    if (zaehlertyp == "Zweitarifzähler" && (typ == "Strom" || typ == "Wärmestrom")) {
      // NT
      let arbeitspreis_nt = 0;
      let arbeitspreisValueNt = tarifeCard.querySelector(
        ".arbeitspreis .value_nt"
      );
      arbeitspreisValueNt = arbeitspreisValueNt.innerHTML;
      arbeitspreisValueNt = arbeitspreisValueNt
        .replace("NT", "")
        .replace("Cent", "")
        .replace(" ", "")
        .replace(",", ".");
      arbeitspreis_nt = parseFloat(arbeitspreisValueNt);

      // HT
      let arbeitspreis_ht = 0;
      let arbeitspreisValueHt = tarifeCard.querySelector(
        ".arbeitspreis .value_ht"
      );
      arbeitspreisValueHt = arbeitspreisValueHt.innerHTML;
      arbeitspreisValueHt = arbeitspreisValueHt
        .replace("HT", "")
        .replace("Cent", "")
        .replace(" ", "")
        .replace(",", ".");
      arbeitspreis_ht = parseFloat(arbeitspreisValueHt);

      gesamtpreisValue =
        (grundpreis * 12 +
          (arbeitspreis_nt * jahresverbrauch_nt +
            arbeitspreis_ht * jahresverbrauch_ht) /
            100) /
        12;
    } else {
      // Strom / Wärmestrom, Eintarifzähler
      if (typ == "Strom" || typ == "Wärmestrom") {
        let arbeitspreis = 0;
        let arbeitspreisValue = tarifeCard.querySelector(
          ".arbeitspreis .value"
        );
        arbeitspreisValue = arbeitspreisValue.innerHTML;
        arbeitspreisValue = arbeitspreisValue
          .replace("Cent", "")
          .replace(" ", "")
          .replace(",", ".");
        arbeitspreis = parseFloat(arbeitspreisValue);

        gesamtpreisValue =
          (grundpreis * 12 + (arbeitspreis * jahresverbrauch) / 100) / 12;
      }

      // Gas
      else {
        // --------------------------------------------------
        // Arbeitspreis
        // --------------------------------------------------

        let arbeitspreis = 0;
        let arbeitspreisWraps = tarifeCard.querySelectorAll(
          ".arbeitspreis .value_wrap"
        );
        let arbeitspreisValue;
        arbeitspreisWraps.forEach(function (arbeitspreisWrap) {
          if (jahresverbrauch > arbeitspreisWrap.dataset.jahresverbrauch) {
            arbeitspreisValue = arbeitspreisWrap;
            return true;
          }
        });
        if (arbeitspreisValue) {
          arbeitspreisValue.classList.add("is_active");
        }

        arbeitspreisValue = arbeitspreisValue.querySelector(".value").innerHTML;
        arbeitspreisValue = arbeitspreisValue
          .replace("Cent", "")
          .replace(" ", "")
          .replace(",", ".");
        arbeitspreis = parseFloat(arbeitspreisValue);

        // --------------------------------------------------
        // Grundpreis
        // --------------------------------------------------

        grundpreis = 0;
        let grundpreisWraps = tarifeCard.querySelectorAll(
          ".grundpreis .value_wrap"
        );
        grundpreisWraps.forEach(function (grundpreisWrap) {
          if (jahresverbrauch > grundpreisWrap.dataset.jahresverbrauch) {
            grundpreisValue = grundpreisWrap;
            return true;
          }
        });
        if (grundpreisValue) {
          grundpreisValue.classList.add("is_active");
        }

        grundpreisValue = grundpreisValue.querySelector(".value").innerHTML;
        grundpreisValue = grundpreisValue
          .replace("€", "")
          .replace(" ", "")
          .replace(",", ".");
        grundpreis = parseFloat(grundpreisValue);

        gesamtpreisValue =
          (grundpreis * 12 + (arbeitspreis * jahresverbrauch) / 100) / 12;
      }
    }

    let rabatt = tarifeCard.querySelector(".rabatt");
    if (rabatt) {
      let rabattValue = rabatt.querySelector(".value").innerHTML;
      rabattValue = parseFloat(
        rabattValue.replace("%", "").replace(" ", "").replace(",", ".")
      );
      gesamtpreisValue = gesamtpreisValue - rabattValue / 12;
    }

    // gesamtpreisValue = gesamtpreisValue.toFixed(2).toLocaleString("de-DE", {
    //   minimumFractionDigits: 2,
    //   maximumFractionDigits: 2,
    // });

    gesamtpreisValue = new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(gesamtpreisValue);

    gesamtpreis.innerHTML = gesamtpreisValue;
    tarifeCard.querySelector(".kosten").classList.remove("is_hidden");
    tarifeCard.closest(".tarife_cards_inner").flkty.resize();
  });
}

// Tarifrechner
let tarifrechner = document.querySelector(".tarifrechner");
if (tarifrechner) {
  let form = tarifrechner.querySelector("form");

  function checkTarifrechner() {
    // Typ
    let typ = "Strom";
    let typInput = tarifrechner.querySelector('input[name="typ"]:checked');
    if (typInput) {
      typ = typInput.value;
    }

    // Kunde
    let kunde = false;
    let kundeInput = tarifrechner.querySelector('input[name="kunde"]:checked');
    if (kundeInput) {
      kunde = kundeInput.value;
    }

    // Zählertyp
    let zaehlertyp = false;
    let zaehlertypInput = tarifrechner.querySelector(
      'input[name="zaehlertyp"]:checked'
    );
    if (zaehlertypInput) {
      zaehlertyp = zaehlertypInput.value;
    }

    let jahresverbrauch;

    // Jahresverbaruch
    if (zaehlertyp == "Zweitarifzähler") {
      jahresverbrauch = [];
      let jahresverbrauchNtInput = tarifrechner.querySelector(
        'input[name="jahresverbrauch_nt"]'
      );
      if (jahresverbrauchNtInput) {
        jahresverbrauch.push(jahresverbrauchNtInput.value);
      }
      let jahresverbrauchHtInput = tarifrechner.querySelector(
        'input[name="jahresverbrauch_ht"]'
      );
      if (jahresverbrauchHtInput) {
        jahresverbrauch.push(jahresverbrauchHtInput.value);
      }
    } else {
      jahresverbrauch = 0;
      let jahresverbrauchInput = tarifrechner.querySelector(
        'input[name="jahresverbrauch"]'
      );
      if (jahresverbrauchInput) {
        jahresverbrauch = jahresverbrauchInput.value;
      }
    }

    filterTarife(zaehlertyp, kunde);
    rechneTarife(typ, jahresverbrauch);
  }

  checkTarifrechner();

  let personen = tarifrechner.querySelectorAll(
    'input[name="personen"], input[name="wohnflaeche"]'
  );
  personen.forEach((person) => {
    let jahresverbrauch = person
      .closest(".tarifrechner")
      .querySelector('input[name="jahresverbrauch"]');
    if (jahresverbrauch) {
      person.addEventListener("change", function () {
        jahresverbrauch.value = person.value;
      });
    }
  });
}

// Get all inputs that have a parent with data-only-allow
let restrictedInputs = document.querySelectorAll(
  ".form_field[data-only-allow] input"
);

restrictedInputs.forEach(function (input) {
  let formField = input.closest(".form_field");
  let allowedValues = formField.getAttribute("data-only-allow").split(";");
  let customMessage = formField.getAttribute("data-only-allow-message");

  input.addEventListener("change", function () {
    console.log("change!");

    let value = input.value;
    let allowed = allowedValues.includes(value);

    if (value && !allowed) {
      input.value = "";

      if (input.matches(".tarifrechner *")) {
        alert(customMessage);
      } else {
        if (!formField.querySelector(".error")) {
          let errorElement = document.createElement("div");
          errorElement.classList.add("error");
          formField.appendChild(errorElement);
        }
        formField.querySelector(".error").textContent = customMessage;
      }
    } else if (formField.querySelector(".error")) {
      formField.querySelector(".error").remove();
    }
  });
});

// Product Details
let productSelect = document.querySelector('.t_order select[name="Produkt"]');
if (productSelect) {
  let activeProduct = productSelect.options[productSelect.selectedIndex];
  function showProductDetail() {
    let productDetails = document.querySelector(
      ".product_details[data-product='" + activeProduct.value + "']"
    );
    let productDetailsAll = document.querySelectorAll(".product_details");
    productDetailsAll.forEach(function (productDetail) {
      productDetail.classList.remove("is_active");
    });
    if (productDetails) {
      productDetails.classList.add("is_active");
    }
  }
  showProductDetail();
  productSelect.addEventListener("change", function () {
    activeProduct = productSelect.options[productSelect.selectedIndex];
    showProductDetail();
  });
} // When Conditions
let whenFields = document.querySelectorAll(".form_field[data-when]");

whenFields.forEach(function (whenField) {
  let whenName = whenField.getAttribute("data-when").split("=")[0];
  let whenValue = whenField.getAttribute("data-when").split("=")[1];
  let contains = false;

  if (whenValue.startsWith("*")) {
    contains = true;
    whenValue = whenValue.replace("*", "");
  }

  let whenFieldField = document.querySelector(`[name="${whenName}"]`);

  if (whenFieldField) {
    function hideField() {
      whenField.classList.add("hidden");

      // Toggle required
      let requiredElements = whenField.querySelectorAll("[required]");
      requiredElements.forEach(function (requiredElement) {
        requiredElement.removeAttribute("required");
        requiredElement.setAttribute("data-required", "true");
      });
    }

    function showField() {
      whenField.classList.remove("hidden");

      // Toggle required
      let requiredElements = whenField.querySelectorAll("[data-required]");
      requiredElements.forEach(function (requiredElement) {
        requiredElement.removeAttribute("data-required");
        requiredElement.setAttribute("required", "true");
      });
    }

    function checkWhen() {
      let fieldValue =
        whenFieldField.tagName.toLowerCase() === "select"
          ? whenFieldField.options[whenFieldField.selectedIndex].value
          : whenFieldField.value;

      if (contains) {
        if (fieldValue.includes(whenValue)) {
          showField();
        } else {
          hideField();
        }
      } else {
        if (fieldValue === whenValue) {
          showField();
        } else {
          hideField();
        }
      }
    }

    checkWhen();
    whenFieldField.addEventListener("change", checkWhen);
    whenFieldField.addEventListener("input", checkWhen);
  }
});

// Wasserquellen

let watercheckBlocks = document.querySelectorAll(".watercheck_block");
watercheckBlocks.forEach(function (watercheckBlock) {
  let streetSelect = watercheckBlock.querySelector("select.streets");
  let analyses = watercheckBlock.querySelectorAll(".analysis");
  let files = watercheckBlock.querySelectorAll(".file");

  NiceSelect.bind(streetSelect, {
    searchable: true,
  });

  let niceSelect = watercheckBlock.querySelector(".nice-select");

  let search = niceSelect.querySelector(".nice-select-search");
  let list = niceSelect.querySelector(".list");

  search.setAttribute("tabindex", "-1");
  list.setAttribute("tabindex", "-1");

  let observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target.classList.contains("open")) {
        search.setAttribute("tabindex", "0");
        list.setAttribute("tabindex", "0");
      } else {
        search.setAttribute("tabindex", "-1");
        list.setAttribute("tabindex", "-1");
      }
    });
  });

  observer.observe(niceSelect, {
    attributes: true,
    attributeFilter: ["class"],
  });

  streetSelect.addEventListener("change", function () {
    let streetFile =
      streetSelect.options[streetSelect.selectedIndex].getAttribute(
        "data-file"
      );

    let values = streetSelect.options[streetSelect.selectedIndex].value;
    values = values.split(";");

    let visibleAnalyses = [];

    analyses.forEach(function (analysis) {
      let match = false;

      values.forEach((value) => {
        if (value && analysis.dataset.analysis === value) {
          match = true;
        }
      });

      if (match) {
        visibleAnalyses.push(analysis);
        gsap.set(analysis, {
          display: "grid",
        });
      } else {
        gsap.set(analysis, {
          display: "none",
        });
      }
    });

    if (!visibleAnalyses.length) {
      gsap.set(
        watercheckBlock.querySelector(".analysis:not([data-analysis])"),
        {
          display: "grid",
        }
      );
    }

    files.forEach(function (file) {
      if (file && file.dataset.file === streetFile) {
        file.classList.add("active");
      } else {
        file.classList.remove("active");
      }
    });
  });
});
